import React, { useState } from 'react';
import { MapContainer, TileLayer, Polygon } from 'react-leaflet';
import { DatePicker, DatePickerInput } from '@carbon/react';
import 'leaflet/dist/leaflet.css';
import './index.scss';

const dummyAreas = [
  {
    name: 'Alta',
    color: '#e57373',
    coordinates: [
      [41.294, -3.23],
      [41.294, -3.228],
      [41.292, -3.228],
      [41.292, -3.23]
    ]
  },
  {
    name: 'Media',
    color: '#64b5f6',
    coordinates: [
      [41.291, -3.226],
      [41.291, -3.224],
      [41.289, -3.224],
      [41.289, -3.226]
    ]
  },
  {
    name: 'Baja',
    color: '#ba68c8',
    coordinates: [
      [41.293, -3.222],
      [41.293, -3.220],
      [41.291, -3.220],
      [41.291, -3.222]
    ]
  }
];

const HeatMapPark = ({ center = [41.2829715, -3.2274719], zoom = 15 }) => {
  const [, setDates] = useState([null, null]);

  const handleDateChange = (eventOrDates) => {
    if (Array.isArray(eventOrDates)) {
      setDates(eventOrDates);
    }
  };

  return (
    <div className="heatmap-container">
      <h3>Mapa de Calor del Parque</h3>

      <div className="heatmap-picker">
        <DatePicker 
          datePickerType="range" 
          onChange={handleDateChange}         
          locale = "es"
          dateFormat = "d/m/Y">
          <DatePickerInput
            id="heatmap-date-picker-start"
            labelText="Fecha de inicio"
            placeholder="dd/mm/yyyy"
          />
          <DatePickerInput
            id="heatmap-date-picker-end"
            labelText="Fecha de fin"
            placeholder="dd/mm/yyyy"
          />
        </DatePicker>
      </div>

      <div className="heatmap-map">
        <MapContainer
          center={center}
          zoom={zoom}
          scrollWheelZoom={false}
        >
          <TileLayer
            attribution='&copy; OpenStreetMap'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {dummyAreas.map((area, i) => (
            <Polygon
              key={i}
              positions={area.coordinates}
              pathOptions={{ color: area.color, fillOpacity: 0.5 }}
            />
          ))}
        </MapContainer>
      </div>

      <div className="heatmap-legend">
        <strong>Concentración:</strong>
        <ul>
          {dummyAreas.slice().reverse().map((area, index) => (
            <li key={index}>
              <span style={{ backgroundColor: area.color }}></span>
              {area.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HeatMapPark;
